import React from "react";
import cx from "classnames";
function WithAside({ children }) {
    return <section className="with-aside" aria-label="Content with sidebar">{children}</section>;
}
export default WithAside;
export function Aside({ children, className, ...props }) {
    return (<section className={cx("aside", className)} aria-label="Sidebar content" {...props}>
      {children}
    </section>);
}
function MainContentCard({ children, className, ...props }) {
    return (<div className={cx("main-content-card", className)} {...props}>
      {children}
    </div>);
}
export function Main({ children, className, ...props }) {
    return (<section className={cx("main", className)} aria-label="Article content" {...props}>
      <MainContentCard>{children}</MainContentCard>
    </section>);
}
export function MainHeader({ children, className, ...props }) {
    return (<div className={cx("main-header", className)} {...props}>
      {children}
    </div>);
}
export function MainBody({ children, className, ...props }) {
    return (<div className={cx("main-body", className)} {...props}>
      {children}
    </div>);
}
export function MainFooter({ children, className, ...props }) {
    return (<div className={cx("main-footer", className)} {...props}>
      {children}
    </div>);
}
